/**
 * Cores padronizadas para métricas de impacto ambiental - Jadlog
 * Usado em todos os gráficos e KPIs da página de Dados de Impacto Jadlog
 * para garantir consistência visual
 */

export const IMPACT_METRIC_COLORS_JADLOG = {
  // Métricas principais Jadlog
  co2: '#16A34A',        // Verde - Carbono Evitado
  energy: '#F59E0B',     // Âmbar/Amarelo - Energia Gerada
  recovered: '#0D9488',  // Teal - Material Gerado
  landfill: '#6B7280',   // Cinza - Espaço Poupado
  fertilizer: '#22C55E', // Verde claro - Fertilizante Gerado
  
  // Alias para uso em gráficos com nomenclatura diferente
  energia: '#F59E0B',    // Alias para energy
  material: '#0D9488',   // Alias para recovered
  aterro: '#6B7280',     // Alias para landfill
} as const;

// Labels padronizados para métricas - Jadlog
export const IMPACT_METRIC_LABELS_JADLOG = {
  co2: 'Carbono Evitado (kg)',
  energy: 'Energia Gerada (kWh)',
  energia: 'Energia Gerada (kWh)',
  recovered: 'Material Gerado (kg)',
  material: 'Material Gerado (kg)',
  landfill: 'Espaço Poupado (m³)',
  aterro: 'Espaço Poupado (m³)',
  fertilizer: 'Fertilizante Gerado (kg)',
} as const;

// Função helper para obter cor de métrica
export const getImpactMetricColorJadlog = (metricKey: string): string => {
  return IMPACT_METRIC_COLORS_JADLOG[metricKey as keyof typeof IMPACT_METRIC_COLORS_JADLOG] || '#10B981';
};

// Função helper para obter label de métrica
export const getImpactMetricLabelJadlog = (metricKey: string): string => {
  return IMPACT_METRIC_LABELS_JADLOG[metricKey as keyof typeof IMPACT_METRIC_LABELS_JADLOG] || metricKey;
};
